import { createSlice } from '@reduxjs/toolkit'
import { decryptText } from '../../utils/utils';
import { LoginResponse } from '../../utils/dto/response/auth';

const auth = JSON.parse(decryptText(localStorage.getItem('user_auth_session')) || '{}');

const initialState: LoginResponse = {
	user_details: auth.user_details || null,
	token: auth.token || null,
	session_expires: auth.session_expires || null,
}

const authUserSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAuthUser: (state, action) => {
			return {...state, ...action.payload};
		},
		deleteAuthUser: () => {
			return { user_details: null, token: null, session_expires: null };
		}
	},
});

export const { setAuthUser, deleteAuthUser } = authUserSlice.actions;

export default authUserSlice.reducer